import { put, call, select } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { updateUiAction } from 'actions/uiActions'
import { offlineSelector } from 'selectors'
import { OFFLINE_TIME_LIMIT } from 'helpers/globals'

export default function * () {
  // skip timer for development and staging
  if (ENV === 'development' || ENV === 'staging') return

  yield call(delay, OFFLINE_TIME_LIMIT)

  const { offline } = yield select(offlineSelector)

  if (offline) yield put(updateUiAction({ modal: 'LoginForm', offlineTimeLimit: true }))
}



// WEBPACK FOOTER //
// ./src/sagas/offlineTimerSaga.js